import React from 'react';
import About from '../components/About/About';
import Banner from '../components/Banner/Banner';
import Faq from '../components/Faq/Faq';
import Footer from '../components/Footer/Footer';
import Method from '../components/Method/Method';
import Navbar from '../components/Navbar/Navbar';
import Process from '../components/Process/Process';
import RoadMap from '../components/RoadMap/RoadMap';
import Team from '../components/Team/Team';
import Utilities from '../components/Utilities/Utilities';

export default function Layout() {
  return (
    <>
        <Navbar />
        <Banner />
        <About />
        <RoadMap />
        <Method />
        <Utilities />
        <Team />
        <Process />
        <Faq />
        <Footer />
    </>
  )
}
